'use strict';

angular.module('shiftTraderApp')
    .directive('saPageIndicator', ['$timeout', '$compile', function($timeout, $compile) {

    return {
      template: '<div class="sa_page_indicator_container"></div>',
      scope: {
        activePage: '=',
        numPages: '='
      },
      link: function(scope) {
        var numPages = null;

        scope.$watch('numPages', function(newVal, oldVal) {
          if (newVal !== numPages) {
            numPages = newVal;
            renderDots();
          }
        });

        function renderDots() {
          $('.sa_page_indicator_dot').remove();
          var templateString = '';

          lodash.each(lodash.range(numPages), function(i) {
            templateString += '<div class="sa_page_indicator_dot" ' +
                'data-ng-class="{active: activePage === ' + i + '}">' +
                '</div>';
          });
          $('.sa_page_indicator_container').append($compile(templateString)(scope));
        }
      }
    };
  }]);
